<template>
  <component :is="`h${level}`" class="heading">
    <slot></slot>
  </component>
</template>

<script>
  export default {
    props: {
      level: {
        default: 2,
        type: [Number, String]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .heading {
    text-align: center;
    font-weight: bold;
    font-size: 33px;
    line-height: 37px;
    margin: 0 auto;
    max-width: 600px;
  }
</style>